import { Award, Privilege } from './api-response';

export enum SabaCoinEventRulesTypeEnum {
	SabaCoinEvent,
	RewardLevel
}

export const RewardScene = {
	BeginnersPackPopup: 'BeginnersPackPopup',
	EventList: 'EventList',
	ExpHistory: 'ExpHistory',
	Home: 'Home',
	JackPotNotice: 'JackPotNotice',
	LevelupPopup: 'LevelupPopup',
	MyVouchers: 'MyVouchers',
	NewVersion: 'NewVersion',
	None: 'None',
	NotUsed: 'NotUsed',
	OddsBoosterGift: 'OddsBoosterGift',
	PurchaseConfirm: 'PurchaseConfirm',
	Ranking: 'Ranking',
	RankingRules: 'RankingRules',
	RewardGift: 'RewardGift',
	RfbInfo: 'RfbInfo',
	Rule: 'Rule',
	SabaCoinRecord: 'SabaCoinRecord',
	SignInResult: 'SignInResult',
	SignInSpin: 'SignInSpin',
	Shop: 'Shop',
	UM: 'UM',
	VoucherRecord: 'VoucherRecord',
	WeeklyAwards: 'WeeklyAwards',
};

export const VoucherQuotaType = {
	Fixed: 1,
	Currency: 2
}

export const VoucherType = {
	OddsBooster: 1,
	RiskFreeBet: 2,
	CashExchange: 3,
	//TurnOver: 4,
	NicknameChange: 5,
	//BehaviorRiskFreeBet: 6,
	FreeOddsBooster: 7,
	BetterCashExchange: 8,
	BestCashExchange: 9,
	NewRiskFreeBet: 10,
	AffPromotionOddsBoost: 11,
	StandardCashExchange: 12,
	GoodCashExchange: 13,
	GiftRiskFreeBet: 14,
	FreeBet: 15,
}

export const VoucherSystemVersion = {
	Original: 0,
	PromotionSuite: 1,
}

export const PromotionSuiteVoucherStatus = {
	Usable: 1,
	Used: 2,
	Expired: 3,
	Recalled: 4,
	NotYetEffective: 5,
}

export const PromotionType = {
	Common: 1,
	Customized: 2,
}

export const VoucherConditionMode = {
	Common: 1,
	AllSports: 2,
	SpecificSports: 3,
}

export const ValidationMode = {
	ALLOW: 1,  // 支援 (list 內的允許)
	DENY: 2    // 不支援 (list 內的拒絕)
}

export const VoucherReasonType = {
	Ranking: 1,
	PeriodSettlement: 2,
	SignIn: 3,
	Event: 4,
	Purchase: 5,
	Promotion: 6,
	WCDailyLuckySpin: 7,
	WCWeeklyPrize: 8,
	FreeBetStreamer: 9,
	FreeBetCustomized: 10,
	Saba: 11,
}

export const SabaCoinReason = {
	Ranking: 1,
	Rebate: 2,
	SignIn: 3,
	Event: 4,
	OddsBooster: 5,
	RiskFreeBet: 6,
	CashExchange: 7,
	//SabaCoinFlow: 8,
	//CustomerDeepConversation: 9,
	NicknameChange: 10,
	BetterCashExchange: 11,
	BestCashExchange: 12,
	NewRiskFreeBet: 13,
	StandardCashExchange: 14,
	GoodCashExchange: 15,
}

export const RewardType = {
	SignIn: 1,
	Betting: 2,
	Parlay: 3,
	Streamer: 5,
	LevelUp: 6,
	Survey: 7,
	BookedBet: 8
};

export const AwardType = {
	/// <summary>
	/// 轉盤遊戲
	/// </summary>
	SpinGame: 1,
	/// <summary>
	/// 沙巴幣
	/// </summary>
	SabaCoin: 2,
	/// <summary>
	/// 加水券
	/// </summary>
	OddsBooster: 3,
	/// <summary>
	/// 零風險券
	/// </summary>
	FreeRiskBet: 4,
	/// BookBet: 5
	/// <summary>
	/// 改名券
	/// </summary>
	NicknameChange: 6,
	/// <summary>
	/// 改版零風險券
	/// </summary>
	NewRiskFreeBet: 7
};

export const PlatformConstant = {
	Mars: 'Mars',
	Galaxy: 'Galaxy'
};

export const Privileges: Privilege[] = [
	{
		Rebate: 0,
		SabaCoin: 0.5
	},
	{
		Rebate: 2,
		SabaCoin: 0.5
	},
	{
		Rebate: 3,
		SabaCoin: 1
	},
	{
		Rebate: 4,
		SabaCoin: 1.5,
		WeeklyAwards: [
			{
				AwardType: AwardType.NewRiskFreeBet,
				Amount: 1
			}
		]
	},
	{
		Rebate: 6,
		SabaCoin: 2,
		WeeklyAwards: [
			{
				AwardType: AwardType.NewRiskFreeBet,
				Amount: 1
			}
		]
	},
	{
		Rebate: 7,
		SabaCoin: 2,
		WeeklyAwards: [
			{
				AwardType: AwardType.NewRiskFreeBet,
				Amount: 2
			}
		]
	},
	{
		Rebate: 8,
		SabaCoin: 2,
		WeeklyAwards: [
			{
				AwardType: AwardType.NewRiskFreeBet,
				Amount: 3
			}
		]
	},
	{
		Rebate: 8,
		SabaCoin: 2.5,
		WeeklyAwards: [
			{
				AwardType: AwardType.NewRiskFreeBet,
				Amount: 3
			}
		]
	},
	{
		Rebate: 8,
		SabaCoin: 2.5,
		WeeklyAwards: [
			{
				AwardType: AwardType.NewRiskFreeBet,
				Amount: 5
			}
		]
	},
];

//每週獎勵_1
export const WeeklyAwards_First = [
	{ AwardType: AwardType.NewRiskFreeBet, Amount: 3 },
	{ AwardType: AwardType.SabaCoin, Amount: 500 }
];

//每週獎勵_2
export const WeeklyAwards_Second = [
	{ AwardType: AwardType.NewRiskFreeBet, Amount: 2 },
	{ AwardType: AwardType.SabaCoin, Amount: 200 }
];

//每週獎勵_3
export const WeeklyAwards_Third = [
	{ AwardType: AwardType.NewRiskFreeBet, Amount: 2 },
	{ AwardType: AwardType.SabaCoin, Amount: 100 }
];

//每週獎勵_4-5
export const WeeklyAwards_Middle = [
	{ AwardType: AwardType.NewRiskFreeBet, Amount: 1 },
	{ AwardType: AwardType.SabaCoin, Amount: 50 }
];

//每週獎勵_6-10
export const WeeklyAwards_Final = [
	{ AwardType: AwardType.NewRiskFreeBet, Amount: 1 },
	{ AwardType: AwardType.SabaCoin, Amount: 20 }
];

//每週獎勵有幾個區塊
export const WeeklyAwardsType: { [key: number]: Award[] } = {
	1: WeeklyAwards_First,
	2: WeeklyAwards_Second,
	3: WeeklyAwards_Third,
	4: WeeklyAwards_Middle,
	5: WeeklyAwards_Final
}

export enum SabaCoinRedemptionStatus {
	NotAchieved = 'NotAchieved',
	AchievedButNotRedeemed = 'AchievedButNotRedeemed',
	Redeemed = 'Redeemed'
}